import { render, staticRenderFns } from "./TheManageItemButtons.vue?vue&type=template&id=56441442&scoped=true"
import script from "./TheManageItemButtons.vue?vue&type=script&lang=js"
export * from "./TheManageItemButtons.vue?vue&type=script&lang=js"
import style0 from "./TheManageItemButtons.vue?vue&type=style&index=0&id=56441442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56441442",
  null
  
)

export default component.exports